<template>
	<div class="page-in">
		<van-nav-bar :title="$t('收货地址')" fixed placeholder left-arrow z-index="99" @click-left="back" :border="false"
			v-if="isMobileFlag" />
		<div class="inside-page">
			<!-- 手机 -->
			<div class="m-container" v-if="isMobileFlag">
				<div class="address-m" v-for="(item,index) in addressData" :key="index" :class="{checked : item.is_default}">
					<div class="flex-col">
						<div class="m-address-row" style="max-width: 70%;">
							{{item.detail}}{{item.is_default}}
						</div>
						<div class="m-address-row ">
							{{item.provinces}} - {{item.area}} - {{item.wards}}
						</div>
						<div class="m-address-row flex">
							<div class="item">{{item.name}}</div>
							<div class="item">{{item.phone}}</div>
						</div>
					</div>
					<div class="m-action">
						<el-link type="info" @click="showEdit(item.id)">{{$t('修改')}}</el-link>
						<el-link type="info" @click="delAddress(item.id)">{{$t('删除')}}</el-link>
					</div>
				</div>
				<button class="layui-btn layui-btn-add" @click="showEdit(9999)">
					+{{$t('新增地址')}}
				</button>
			</div>
			<!-- pc -->
			<div class="layui-container" v-else>
				<div class="ucenter">
					<div class="uc-breadcrumb">
						<el-link type="info" @click="back">
							<span class="iconfont icon-l-left"></span><span>{{$t('返回')}}</span>
						</el-link>
					</div>
					<UserPanel></UserPanel>
					<div class="ucenter-ht"></div>
					<div class="ucenter-content">
						<div class="ucenter-cell">
							<div class="address-cells">
								<div class="ucenter-content-hd">
									<span class="tt">{{$t('收货地址')}}</span>
									<button class="layui-btn layui-btn-add" @click="showEdit(9999)">
										+{{$t('新增地址')}}
									</button>
								</div>
								<el-row :gutter="30" type="flex" >
									<el-col :span="12" v-for="(item,index) in addressData" :key="index">
										<div class="address-panel"  :class="{checked : item.is_default}">
											<div class="flex-col">
												<div class="address-row">
													<div class="label">{{$t('姓名')}}</div>
													<div class="flex-col">{{item.name}}</div>
												</div>
												<div class="address-row">
													<div class="label">{{$t('收货地址')}}</div>
													<div class="flex-col">
														{{item.provinces}} - {{item.area}} - {{item.wards}}
													</div>
												</div>
												<div class="address-row">
													<div class="label">{{$t('详细地址')}}</div>
													<div class="flex-col">{{item.detail}}</div>
												</div>
												<div class="address-row">
													<div class="label">{{$t('电话号码')}}</div>
													<div class="flex-col">{{item.phone}}</div>
												</div>
											</div>
											<div class="adr-action">
												<el-link type="info" @click="showEdit(item.id)">{{$t('修改')}}</el-link>
												<el-link type="info" @click="delAddress(item.id)">{{$t('删除')}}</el-link>
											</div>
										</div>
									</el-col>
								</el-row>
								
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<editAddress ref="editAddress" @update-addresses="getAddress" :addressId="aId"></editAddress>
	</div>
</template>
<script>
	import UserPanel from './components/UserPanel'
	import editAddress from './components/editAddress'
	import {
		address_api,
		address_delete_api
	} from "@/api/user"
	import empty from '@/components/empty.vue'
	export default {
		components: {
			UserPanel,
			editAddress,
			empty
		},
		data() {
			return {
				addressData: [],
				aId: 0,
			};
		},
		methods: {
			async getAddress() {
				const loading = this.$loading({
					lock: true,
					text: '',
					spinner: 'loader',
					background: 'rgba(255, 255, 255, 0.3)'
				});
				await address_api().then(res => {
					if (res && res.data.code == 1) {
						this.addressData = res.data.data.list
					}
					loading.close()
				});
			},
			async delAddress(aid) {
				let data = {
					id: aid
				}
				await this.$confirm(this.$t('是否要删除地址?'), '', {
					confirmButtonText: this.$t('确定'),
					cancelButtonText: this.$t('取消'),
					type: 'warning'
				}).then(() => {
					const loading = this.$loading({
						lock: true,
						text: '',
						spinner: 'loader',
						background: 'rgba(255, 255, 255, 0.3)'
					});
					address_delete_api(data).then(res => {
						loading.close();
						if (res && res.data.code == 1) {
							this.getAddress()
							this.successTips(res.data.msg)
						} else {
							this.errorTips(res.data.msg)
						}
					});
				}).catch(() => {});

			},
			showEdit(Id) {
				this.aId = Id
				this.$nextTick(() => {
					this.$refs.editAddress.showEditDialog();
				});
			},
		},
		mounted() {
			this.isCheckLogin()
			this.getAddress()
		}
	}
</script>
<style scoped>
	.uc-breadcrumb {
		margin-bottom: 15px;
	}

	.ucenter-ht {
		height: 20px;
	}

	.address-cells {
		margin-bottom: 30px;
	}
	.address-cells .el-row{
		flex-wrap: wrap;
	}
	.address-cells .el-row >div{
		margin-bottom: 20px;
	}
	.address-panel {
		position: relative;
		display: flex;
		padding: 20px;
		height: 100%;
		border: 1px solid #404040;
	}
	.address-panel.checked::before{
		content: '';
		position: absolute;
		width: 48px;
		height: 30px;
		background: url(../../assets/images/selected.png) no-repeat;
		background-size: 100% 100%;
		right: 0;
		bottom: 0;
	}

	.address-row {
		display: flex;
		align-items: center;
		padding: 5px 0;
	}

	.address-row .label {
		width: 130px;
		opacity: .7;
		margin-right: 40px;
	}
	.adr-action{
		position: absolute;
		right: 20px;
		top: 20px;
	}

	.adr-action .el-link {
		margin-left: 20px;
	}

	/* 手机 */
	.m-address-row {
		padding: 5px 0;

		.item {
			margin-right: 10px;
			color: #909090;
		}
	}

	.address-m {
		position: relative;
		display: flex;
		align-items: center;
		background: #FFFFFF;
		border: 1px dashed #8B6E35;
		margin-bottom: 12px;
		padding: 15px;
	}
	.address-m.checked::after{
		content: '';
		position: absolute;
		width: 32px;
		height: 20px;
		background: url(../../assets/images/selected.png) no-repeat;
		background-size: contain;
		right: 0;
		bottom: 0;
	}
	.m-action{
		position: absolute;
		right: 10px;
		top: 10px;
	}
	.m-action .el-link {
		margin: 10px
	}

	.layui-btn-add {
		background-color: transparent;
		width: 100%;
		border-radius: 43px;
		border: 1px solid #909090;
		margin-top: 20px;
	}

	.m-action .sm-tt {
		font-size: 14px;
	}
	@media(min-width:992px){
		.layui-btn-add{
			display: inline-flex;
			font-size: 14px;
			width: auto;
			padding: 0 15px;
			height: 32px;
			margin-top: 0;
			margin-left: 0;
		}
	}
	
	
</style>